import React from 'react'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import AdvanceSettingForm from './components/AdvanceSettingForm'
import BasicSettingForm from './components/BasicSettingForm'
import FilterOrg from './components/FilterOrg'
import ActionButtons from './components/ActionButtons'
import ExternalInfoForm from './components/ExternalInfoForm'
import MDBox from 'components/MDBox'
function OrgAdmin() {
  return (
    <MDBox  sx={{background:"white !important"}}>
    <DashboardLayout>
      <DashboardNavbar/> 
      
         <FilterOrg/>
      {/* <AdvanceSettingForm/> */}
      <MDBox display="flex" >
        <BasicSettingForm/>
      <AdvanceSettingForm/>
      </MDBox>
      
     
     
       {/* <ExternalInfoForm /> */}
      <ActionButtons/> 
    </DashboardLayout>
     </MDBox>
  )
}

export default OrgAdmin
